import { useState, useEffect, useRef } from 'react';

const RotatingText = ({ texts = [], rotationInterval = 2000, mainClassName = '', style = {} }) => {
  const [index, setIndex] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [translateY, setTranslateY] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!texts.length) return;
    timerRef.current = setInterval(() => {
      // Fade out + slide up
      setOpacity(0);
      setTranslateY(-10);
      setTimeout(() => {
        setIndex(i => (i + 1) % texts.length);
        setTranslateY(10);
        // Fade in from below
        setTimeout(() => {
          setOpacity(1);
          setTranslateY(0);
        }, 50);
      }, 250);
    }, rotationInterval);
    return () => clearInterval(timerRef.current);
  }, [texts.length, rotationInterval]);

  if (!texts.length) return null;

  return (
    <span
      className={mainClassName}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        ...style,
      }}
    >
      <span
        style={{
          display: 'inline-block',
          opacity,
          transform: `translateY(${translateY}px)`,
          transition: 'opacity 0.25s ease, transform 0.25s ease',
          willChange: 'opacity, transform',
        }}
      >
        {texts[index]}
      </span>
    </span>
  );
};

export default RotatingText;
